// test1998
(1998 && 0);
